import { IFieldLangMap } from '@pharmsnap/shared/types'

/** 药物研发状态中非在研聚合项的文案,图表与表格合并展示时使用 */
export const DRUG_DEV_STATUS_LANG: IFieldLangMap = {
  INACTIVE: {
    cn: '非在研',
    en: 'Inactive',
    jp: 'Inactive',
  },
}
